<template>
  <div>
    <rj-tabs v-model="tabsActive">
      <rj-tab-pane name="1" label="待审批退换货合同">
        <waitExchange />
      </rj-tab-pane>
      <rj-tab-pane name="2" label="审批过的退换货合同">
        <approveExchange />
      </rj-tab-pane>
    </rj-tabs>
  </div>
</template>

<script>
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
import waitExchange from './waitExchange.vue';
import approveExchange from './approveExchange.vue';

export default {
  data () {
    return {
      tabsActive: '1'
    };
  },
  computed: {
    // tabsActive: {
    //   get () {
    //     return this.$store.state.pagesTemporary.ChiefOrderListTabActive;
    //   },
    //   set (val) {
    //     this.$store.commit('pagesTemporary/SETChiefOrderListTabActive', val);
    //   }
    // }
  },
  components: {
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs,
    waitExchange,
    approveExchange

  }
};
</script>

<style>

</style>
